import styles from "@/app/styles/components/pages/our-partners/partner-preview.module.scss";
import Link from "next/link";
import {getCDNImage} from "@/app/utils/ImageUtil";

const PartnerPreview = ({partner}) => {

    const imageStyle = {
        backgroundImage: `url(${getCDNImage(partner?.acf?.image)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center'
    }

    return <div className={styles.partner}>
        <Link href={'/nasi-partneri/' + partner.slug}>
            <div style={imageStyle} className={styles.image}/>
        </Link>
        <div className={styles.content}>
            <Link href={'/nasi-partneri/' + partner.slug}>
                <h2>{partner?.title.rendered}</h2>
            </Link>
            <div dangerouslySetInnerHTML={{__html: partner.excerpt.rendered}}/>
        </div>
    </div>
}

export default PartnerPreview